<template>
	<v-layout row wrap justify-start align-start>
		<v-flex>
			<v-form ref="basketAddForm" @submit.prevent="submitType()">
				<v-flex class="pa-0">
					<v-btn-toggle
						active-class="active-select"
						v-model="qty_type"
						tile
						color="deep-purple accent-3"
						group
						mandatory
					>
						<v-layout
							row
							wrap
							justify-start
							align-start
							style="width: 100%; margin: 0"
						>
							<v-flex v-if="boxPriceDisplay.amount > 0" mr-2>
								<v-btn
									outlined
									value="B"
									style="border-color: #00000014"
								>
									<v-layout
										row
										wrap
										justify-start
										align-start
									>
										<v-flex xs12 class="pa-0">Box</v-flex>
										<v-flex v-if="retrieveShowPrices"
											>£{{
												boxPriceDisplay.amount_display
											}}</v-flex
										>
									</v-layout>
								</v-btn>
							</v-flex>
							<v-flex v-if="kiloPriceDisplay.amount > 0" mr-2>
								<v-btn
									outlined
									value="K"
									style="border-color: #00000014"
								>
									<v-layout
										row
										wrap
										justify-start
										align-start
									>
										<v-flex xs12 class="pa-0">Kilo</v-flex>
										<v-flex v-if="retrieveShowPrices"
											>£{{
												kiloPriceDisplay.amount_display
											}}</v-flex
										>
									</v-layout>
								</v-btn>
							</v-flex>

							<v-flex v-if="eachPriceDisplay.amount > 0">
								<v-btn
									outlined
									value="E"
									style="border-color: #00000014"
								>
									<v-layout
										row
										wrap
										justify-start
										align-start
									>
										<v-flex xs12 class="pa-0">{{
											eachUnitOfSale
										}}</v-flex>
										<v-flex
											>£{{
												eachPriceDisplay.amount_display
											}}</v-flex
										>
									</v-layout>
								</v-btn>
							</v-flex>
						</v-layout>
					</v-btn-toggle>
				</v-flex>
				<v-flex class="pt-4" style="width: 100px">
					<v-text-field
						type="number"
						label="Quantity"
						outlined
						@focus="$event.target.select()"
						color="blue darken-2"
						v-model="qty"
						:hint="maxValueHint"
						persistent-hint
						:disabled="retrieveGuest"
						:rules="[rules.qtyRules(qty, qty_type, product)]"
						v-if="!retrieveGuest"
					></v-text-field>
				</v-flex>
				<v-flex v-if="!retrieveGuest">
					<v-textarea
						clearable
						label="Comment"
						type="text"
						outlined
						v-model="comment"
						rows="2"
						auto-grow
						hint="Optional"
						counter
						maxlength="200"
						:disabled="retrieveGuest"
					></v-textarea>
				</v-flex>
				<v-flex
					v-if="
						!product.available_for_sale &&
						!product.qty_type &&
						!retrieveGuest
					"
				>
					<v-chip
						class="ma-0"
						color="error"
						label
						text-color="error"
						outlined
						large
					>
						<!-- <v-icon left>error_outline</v-icon>Not Available -->
						<span class="abc">
							{{ product.available_for_sale_message }}
						</span>
					</v-chip>
					<!-- <div>{{ product.message }}</div> -->
				</v-flex>
				<v-flex class="pa-0">
					<v-layout
						row
						wrap
						justify-start
						align-start
						style="width: 100%; margin: 0 auto"
					>
						<v-flex md8 xs12 v-if="!retrieveGuest">
							<v-btn
								v-if="!isBasketItem"
								color="blue darken-2"
								class="white--text"
								block
								:loading="loadingSubmit"
								@click="submit"
								x-large
								:disabled="
									!product.available_for_sale || retrieveGuest
								"
								>Add to Cart</v-btn
							>
							<v-btn
								v-else
								color="deep-purple base"
								class="white--text"
								block
								:loading="loadingSubmit"
								@click="amend"
								x-large
								>Update Item</v-btn
							>
						</v-flex>
						<v-flex md8 xs12 v-else>
							<v-btn
								v-if="!isBasketItem"
								color="blue darken-2"
								class="white--text"
								block
								:loading="loadingSubmit"
								@click="registerUser"
								x-large
								>Sign up Now</v-btn
							>
						</v-flex>
						<v-flex md4 xs12 class="pa-0">
							<v-layout
								row
								wrap
								justify-start
								align-start
								style="width: 100%; margin: 0 auto"
							>
								<!-- <v-flex v-if="!retrieveGuest && !isBasketItem">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="info"
                        x-large
                        dark
                        outlined
                        block
                        exact
                        :to="{
                          name: 'OrdersSearchProductInfo',
                          params: { id: product.prod_no, product: product },
                        }"
                      >
                        <v-icon>info</v-icon>
                      </v-btn>
                    </template>
                    <span>Additional product info</span>
                  </v-tooltip>
                </v-flex> -->
								<v-flex v-if="!isBasketItem && retrieveGuest">
									<v-btn
										color="info"
										x-large
										dark
										outlined
										block
										exact
										@click.stop="signInUser"
										>Sign In</v-btn
									>
								</v-flex>
								<v-flex
									v-if="
										!retrieveGuest &&
										!$store.getters.retrieveAnon
									"
								>
									<v-tooltip
										v-if="!isBasketItem && !isFavourite"
										bottom
									>
										<template v-slot:activator="{ on }">
											<v-btn
												v-on="on"
												color="favourites"
												x-large
												dark
												outlined
												block
												:loading="loadingFavourite"
												@click="addToFavourites"
											>
												<v-icon
													>mdi-heart-outline</v-icon
												>
											</v-btn>
										</template>

										<span>Add to Favourites</span>
									</v-tooltip>
									<v-tooltip v-else-if="!isBasketItem" bottom>
										<template v-slot:activator="{ on }">
											<v-btn
												v-on="on"
												color="favourites"
												x-large
												dark
												outlined
												block
												:loading="loadingFavourite"
												@click="deleteFromFavourites"
											>
												<v-icon>mdi-heart</v-icon>
											</v-btn>
										</template>

										<span>Remove from Favourites</span>
									</v-tooltip>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex v-if="!isBasketItem && showReview">
					<span
						class="pl-2 grey--text text--darken-2 font-weight-light caption"
						>16,544 reviews</span
					>
					<v-spacer></v-spacer>
					<v-rating
						background-color="orange lighten-3"
						color="orange"
					></v-rating>
				</v-flex>
				<v-flex>
					<v-textarea
						v-if="!isBasketItem && showReview"
						clearable
						label="Review"
						type="text"
						outlined
						auto-grow
						rows="2"
						placeholder="Please enter your review here"
					></v-textarea>
				</v-flex>
			</v-form>
		</v-flex>
	</v-layout>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
	props: {
		isBasketItem: Boolean,
		product: {},
	},
	data: () => {
		return {
			showReview: false,
			loadingSubmit: false,
			loadingFavourite: false,
			qtyRules: [
				(v) => !!v || "Invalid Qty",
				(v) => v >= 0 || "Invalid Qty",
			],

			// eachMax: this.product.each_max,

			rules: {
				qtyRules(qty, qty_type, product) {
					//We must have a value
					if (!qty || qty <= 0) {
						return "Invalid Qty";
					}

					//Number must be an Int APART FROM IF KILO

					if (qty_type != "K") {
						if (!Number.isInteger(parseFloat(qty))) {
							return "Must be an Integer";
						}
					} else {
						var regex = new RegExp("^[0-9]+(.[0-9]{1,2})?$", "g");

						if (!regex.test(qty)) {
							return "Must be 2 DP";
						}
					}

					//Qty Max
					switch (qty_type) {
						case "B":
							if (qty > product.box_max) {
								return "Max Qty: " + product.box_max;
							}
							break;
						case "K":
							if (qty > product.kilo_max) {
								return "Max Qty: " + product.kilo_max;
							}
							break;
						case "E":
							if (qty > product.each_max) {
								return "Max Qty: " + product.each_max;
							}
							break;
					}

					return true;
				},
			},

			qty: 1,
			qty_type: "E",
			comment: "",
			review: "",
			isFavourite: false,
		};
	},

	computed: {
		...mapGetters([
			"retrieveGuest",
			"retrieveTrollyItemsOutOfStock",
			"retrieveShowPrices",
		]),

		eachUnitOfSale() {
			let unit = "Each";

			if (this.product.each_unit_of_sale) {
				if (/\S/.test(this.product.each_unit_of_sale)) {
					unit = this.product.each_unit_of_sale;
				}
			}

			return unit;
		},

		boxPriceDisplay() {
			return {
				amount: parseFloat(this.product.box_price).toFixed(2),
				amount_display: parseFloat(this.product.box_price).toFixed(2),
			};
		},

		kiloPriceDisplay() {
			return {
				amount: parseFloat(this.product.kilo_price).toFixed(2),
				amount_display: parseFloat(this.product.kilo_price).toFixed(2),
			};
		},

		eachPriceDisplay() {
			if (
				!this.$store.getters.retrieveIsCncCustomer &&
				!this.$store.getters.retrieveIsCashCustomer &&
				!this.$store.getters.retrieveIsPaymentWithOrderCustomer &&
				parseInt(this.product.catch_weight_flag) == 2
			) {
				console.log("-- Each Price Displaying for Account");
				console.log(this.product.product_no);
				console.log(this.product.kilo_price);
				console.log(parseFloat(this.product.kilo_price));
				console.log(parseFloat(this.product.kilo_price).toFixed(2));

				return {
					amount: parseFloat(this.product.kilo_price).toFixed(2),
					amount_display:
						parseFloat(this.product.kilo_price).toFixed(2) + "/kg",
				};
			} else {
				console.log("-- Each Price Displaying for Cash");
				console.log(this.product.product_no);
				console.log(this.product.each_price);
				console.log(parseFloat(this.product.each_price));
				console.log(parseFloat(this.product.each_price).toFixed(2));

				return {
					amount: parseFloat(this.product.each_price).toFixed(2),
					amount_display: parseFloat(this.product.each_price).toFixed(
						2
					),
				};
			}
		},

		maxValueHint() {
			switch (this.qty_type) {
				case "B":
					if (
						this.product.box_max != 9999 &&
						this.product.box_max != undefined
					) {
						return "Max Qty: " + this.product.box_max;
					}
					break;
				case "K":
					if (
						this.product.kilo_max != 9999 &&
						this.product.kilo_max != undefined
					) {
						return "Max Qty: " + this.product.kilo_max;
					}
					break;
				case "E":
					if (
						this.product.each_max != 9999 &&
						this.product.each_max != undefined
					) {
						return "Max Qty: " + this.product.each_max;
					}
					break;
			}

			return "";
		},
	},

	beforeMount() {
		this.checkBasketAmounts();
	},

	watch: {
		product: function (newVal) {
			if (newVal != undefined) {
				this.checkBasketAmounts();
				this.isFavourite = newVal.favorite;
			} else {
				console.log("-- Undefined Product");
				console.log("  -- Look for it here?");
			}
		},
	},

	methods: {
		...mapActions(["setSnackbar", "getTrollys"]),

		submitType() {
			console.log("--Submit Type");
			if (this.isBasketItem) {
				this.amend();
			} else {
				this.submit();
			}
		},

		checkBasketAmounts() {
			//
			if (this.product.qty) {
				this.qty = this.product.qty;
			} else {
				this.qty = 1;
			}

			if (this.product.qty_type) {
				this.qty_type = this.product.qty_type;
			} else {
				//We're not a basket product so re-select just in case

				if (this.product.each_price > 0) {
					this.qty_type = "E";
				} else if (this.product.kilo_price > 0) {
					this.qty_type = "K";
				} else if (this.product.box_price > 0) {
					this.qty_type = "B";
				}
			}

			if (this.product.comment) {
				this.comment = this.product.comment;
			} else {
				this.comment = "";
			}
		},
		async submit() {
			if (this.$refs.basketAddForm.validate()) {
				console.log("Submit");
				console.log(this.qty);
				console.log(this.qty_type);

				console.log(this.$refs.basketAddForm);

				this.loadingSubmit = true;

				let stringPayload = JSON.stringify({
					sessionKey: this.$store.getters.retrieveUser.sessionKey,
					userId: this.$store.getters.retrieveUser.userNum,
					trollyId: this.$store.getters.retrieveCurrentTrolly.id,
					prodNo: this.product.prod_no,
					qtyType: this.qty_type,
					qty: this.qty,
					comment: this.comment,
					br: 0,
				});

				const params = new URLSearchParams();
				params.append("params", stringPayload);

				await axios
					.post("put-trolly-item", params)
					.then((response) => {
						if (response.data.success) {
							//this.setSnackbar({ text: "Item added to basket" });
							this.getTrollys()
								.then((response) => {
									console.log("-- Got Trollys");
									console.log(response);

									if (
										this.retrieveTrollyItemsOutOfStock
											.length > 0
									) {
										//CHECK IF ADDED PRODUCT IS OUT OF STOCK
										const payloadObj =
											JSON.parse(stringPayload);

										const snackObj = {
											color: "warning",
											btnText: "View",
											timeout: 8000,
											redirect: "OrdersBasket",
										};
										let isRecentItem =
											this.retrieveTrollyItemsOutOfStock.some(
												(elem) => {
													return (
														elem.id ===
														payloadObj.prodNo
													);
												}
											);

										if (isRecentItem) {
											snackObj.text =
												"Item you added to Basket is out of stock!";
										} else {
											//CHECK IF ANY OTHER ITEM IN TROLLY IS NOT IN STOCK
											snackObj.text =
												"Item added to basket";
											snackObj.text2 =
												"One or more items in your basket are out of stock";
										}
										this.setSnackbar(snackObj);
									} else {
										this.setSnackbar({
											text: "Item added to basket",
										});
									}
									this.loadingSubmit = false;
									this.$router
										.push({ name: "OrdersSearch" })
										.catch((e) => {
											console.log(e);
										});
								})
								.catch((er) => {
									console.log(er);
									this.loadingSubmit = false;
								});
						} else {
							this.setSnackbar({
								color: "error",
								text: "Error adding item to basket",
							});
							this.loadingSubmit = false;
						}

						this.$emit("closeDialog");
					})
					.catch((err) => {
						console.log(err);
						this.loadingSubmit = false;
					});
			}
		},
		async amend() {
			if (this.$refs.basketAddForm.validate()) {
				console.log("Amend");
				console.log(this.qty);
				console.log(this.qty_type);

				this.loadingSubmit = true;

				let stringPayload = JSON.stringify({
					sessionKey: this.$store.getters.retrieveUser.sessionKey,
					userId: this.$store.getters.retrieveUser.userNum,
					trollyId: this.$store.getters.retrieveCurrentTrolly.id,
					trollyItemId: this.product.id,
					prodNo: this.product.prod_no,
					qtyType: this.qty_type,
					qty: this.qty,
					comment: this.comment,
					br: 0,
				});

				const params = new URLSearchParams();
				params.append("params", stringPayload);

				await axios
					.post("put-trolly-item", params)
					.then((response) => {
						if (response.data.success) {
							this.setSnackbar({ text: "Item Updated" });
							this.$emit("refreshBasket");
						} else {
							this.setSnackbar({
								color: "error",
								text: "Error adding item to basket",
							});
						}
					})
					.catch((err) => {
						console.log(err);
					});

				this.loadingSubmit = false;
			}
		},

		async addToFavourites() {
			this.loadingFavourite = true;

			let stringPayload = JSON.stringify({
				sessionKey: this.$store.getters.retrieveUser.sessionKey,
				userId: this.$store.getters.retrieveUser.userNum,
				productNo: this.product.prod_no,
			});

			const params = new URLSearchParams();
			params.append("params", stringPayload);

			let favouritesFunction = "add-to-favourites";

			if (this.$store.getters.retrieveAdmin.account_type == "C1") {
				if (
					this.$store.getters.retrieveIsCashCustomer ||
					this.$store.getters.retrieveIsCncCustomer
				) {
					favouritesFunction = "add-to-user-favourites";
				}
			} else {
				favouritesFunction = "add-to-user-favourites";
			}

			await axios
				.post(favouritesFunction, params)
				.then((response) => {
					if (response.data.success) {
						this.setSnackbar({ text: "Added to Favourites" });
						this.isFavourite = true;
					} else {
						this.setSnackbar({
							color: "error",
							text: response.data.message,
						});
						this.isFavourite = true;
					}
				})
				.catch((err) => {
					console.log(err);
					this.setSnackbar({
						color: "error",
						text: "Could not amend favourites at this time",
					});
				});

			this.loadingFavourite = false;
		},

		async deleteFromFavourites() {
			this.loadingFavourite = true;

			let stringPayload = JSON.stringify({
				sessionKey: this.$store.getters.retrieveUser.sessionKey,
				userId: this.$store.getters.retrieveUser.userNum,
				productNo: this.product.prod_no,
			});

			const params = new URLSearchParams();
			params.append("params", stringPayload);

			let favouritesFunction = "delete-from-favourites";

			if (this.$store.getters.retrieveAdmin.account_type == "C1") {
				if (
					this.$store.getters.retrieveIsCashCustomer ||
					this.$store.getters.retrieveIsCncCustomer
				) {
					favouritesFunction = "delete-from-user-favourites";
				}
			} else {
				favouritesFunction = "delete-from-user-favourites";
			}

			await axios
				.post(favouritesFunction, params)
				.then((response) => {
					if (response.data.success) {
						this.setSnackbar({ text: "Removed from Favourites" });
						this.isFavourite = false;
					} else {
						this.setSnackbar({
							color: "error",
							text: response.data.message,
						});
						this.isFavourite = false;
					}
				})
				.catch((err) => {
					console.log(err);
					this.setSnackbar({
						color: "error",
						text: "Could not amend favourites at this time",
					});
				});

			this.loadingFavourite = false;
		},
		signInUser() {
			this.$store.dispatch("userSignoutAction");
			this.$router.push({ name: "SignIn" });
		},
		registerUser() {
			this.$router.push({ name: "Registration" });
		},
	},
};
</script>

<style lang="sass" scoped>
.active-select
  border-color: #f57c00 !important
</style>

<style scoped>
.abc {
	max-width: 99%;
	font-size: 11px;
	font-weight: bold;
}
@media (max-width: 450px) {
	.v-chip {
		white-space: normal;
	}
}
</style>
